export default __webpack_public_path__ + "static/media/misc-fireplaceA-768w.5aee6f00.avif";